export class RoleMaster {
  public ROLE_ID!: number;
  public ROLE_NAME!: string;
  public ROLE_SHORT_NAME: any;
  public CREATEDBY_USERID!: number;
  public UPDATEDBY_USERID!: number;
  public CREATED_DATE!: string;
  public UPDATED_DATE!: string;
  public IS_ACTIVE!: boolean;
}
